// TradingViewWidget.jsx
import React, { useEffect, useRef, memo } from "react";

function AppleViewWidget() {
  const container = useRef();

  useEffect(() => {
    const existingScript = document.getElementById("tradingview-widget-script");
    
    if (!existingScript) {
      const script = document.createElement("script");
      script.id = "tradingview-widget-script"; // Add an ID to the script
      script.src =
        "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        {
          "symbols": [
            ["Apple", "AAPL|1D"],
            ["Google", "GOOGL|1D"],
            ["Microsoft", "MSFT|1D"]
          ],
          "chartOnly": false,
          "width": "100%",
          "height": "100%",
          "locale": "en",
          "colorTheme": "dark",
          "isTransparent": true,
          "autosize": true,
          "showVolume": false,
          "showMA": false,
          "hideDateRanges": false,
          "hideMarketStatus": false,
          "hideSymbolLogo": false,
          "scalePosition": "right",
          "scaleMode": "Normal",
          "fontFamily": "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
          "fontSize": "10",
          "noTimeScale": false,
          "valuesTracking": "1",
          "changeMode": "price-and-percent",
          "chartType": "area",
          "maLineColor": "#2962FF",
          "maLineWidth": 1,
          "maLength": 9,
          "headerFontSize": "medium",
          "lineWidth": 2,
          "lineType": 0,
          "dateRanges": ["1d|1", "1m|30", "3m|60", "12m|1D", "60m|1W", "all|1M"]
        }`;
      container.current.appendChild(script);
    }
  }, []);

  return (
    <div
      className="tradingview-widget-container"
      ref={container}
      style={{
        height: "450px",
        padding: "10px",
        borderRadius: "16px",
        backgroundImage: "radial-gradient(circle 815px at 23.4% -21.8%, rgba(9, 29, 85, 1) 0.2%, rgba(0, 0, 0, 1) 100.2%)",
        overflow: "hidden" // Ensure any overflow is hidden
      }}
    >
      <div className="tradingview-widget-container__widget"></div>
      <div style={{ textAlign: "center", marginTop: "8px" }}>
        <a
          href="https://www.tradingview.com/"
          rel="noopener noreferrer"
          target="_blank"
          style={{ color: "#007bff" }}
        >
        </a>
      </div>
    </div>
  );
}

export default memo(AppleViewWidget);
